"use client";
export const dynamic = "force-dynamic";

import {
  Layers,
  UserCheck,
  Instagram,
  Globe,
  Ban,
  CreditCard,
  LifeBuoy,
  ShieldAlert,
  CalendarCheck,
  RefreshCw,
  UserX,
  Copyright,
  Scale,
  Mail,
  LogOut,
  PowerOff,
  Megaphone,
  HardDrive,
  CloudLightning,
  Gavel,
  Bot,
  KeyRound,
} from "lucide-react";
import LegalLayout, {
  LegalList,
  LegalNumbered,
  type LegalSection,
} from "@/components/legal/LegalLayout";

const sections: LegalSection[] = [
  {
    id: "scope",
    title: "دامنهٔ پوشش",
    icon: Layers,
    highlight:
      "این شرایط شامل کلیه سرویس‌های فعلی و آتی ترندی اسمارت می‌شود؛ از مدیریت اینستاگرام تا وب‌سایت و سایر کانال‌های پیام‌رسان.",
    body: (
      <LegalList
        items={[
          "اتصال و مدیریت حساب‌های اینستاگرام (دایرکت، کامنت، استوری، سفارشات).",
          "ابزارهای وب‌سایت شامل چت آنلاین، فرم‌ها، سفارش‌گیری و ابزارهای مشابه.",
          "اتصال به تلگرام، واتس‌اپ، بله و سایر پیام‌رسان‌هایی که در آینده اضافه می‌شوند.",
          "خدمات هوش مصنوعی فارسی شامل پاسخ خودکار، خلاصه‌سازی و دسته‌بندی هوشمند پیام‌ها.",
          "ابزارهای داشبورد، گزارش‌گیری و API توسعه‌دهنده.",
        ]}
      />
    ),
  },
  {
    id: "account",
    title: "حساب کاربری و ثبت‌نام",
    icon: UserCheck,
    body: (
      <LegalList
        items={[
          "ثبت‌نام صرفاً با شماره موبایل معتبر متعلق به خود کاربر مجاز است.",
          "هر کاربر مسئول حفظ محرمانگی نام کاربری، رمز عبور و توکن‌های حساب خود است؛ هرگونه اقدام انجام‌شده با حساب، به نام کاربر ثبت می‌شود.",
          "ورود اطلاعات نادرست، جعلی یا ناقص باعث تعلیق فوری حساب می‌شود.",
          "هر شخص حقیقی تنها مجاز به داشتن یک حساب کاربری اصلی است؛ حساب‌های فرعی برای تیم با اجازه مدیر اصلی قابل تعریف است.",
          "استفاده اشتراکی از یک حساب توسط چند نفر مجاز نیست؛ برای تیم‌ها از قابلیت «اعضای تیم» استفاده کنید.",
        ]}
      />
    ),
  },
  {
    id: "instagram-rules",
    title: "قوانین ویژهٔ اینستاگرام",
    icon: Instagram,
    body: (
      <LegalList
        items={[
          "اتصال تنها برای حساب‌های Business یا Creator که به یک پیج فیسبوک متصل هستند مجاز است.",
          "مسئولیت رعایت کامل قوانین، Community Guidelines و محدودیت‌های API اینستاگرام بر عهده کاربر است.",
          "استفاده برای اسپم، تبلیغات مزاحم، محتوای غیراخلاقی، قمار، شرط‌بندی، فروش VPN غیرمجاز و فروش اقلام غیرقانونی ممنوع است.",
          "در صورت تغییر API، سیاست‌ها یا اعمال محدودیت توسط Meta، ترندی اسمارت مسئولیتی در قبال توقف یا کاهش کیفیت سرویس ندارد.",
          "نرخ ارسال خودکار پیام تابع محدودیت‌های رسمی اینستاگرام است؛ تلاش برای دور زدن این محدودیت‌ها ممنوع است.",
        ]}
      />
    ),
  },
  {
    id: "website-rules",
    title: "قوانین ویژهٔ وب‌سایت",
    icon: Globe,
    body: (
      <LegalList
        items={[
          "استفاده از کدهای ویجت چت و فرم وب ترندی اسمارت تنها در دامنه‌های متعلق به کاربر یا با مجوز قانونی مجاز است.",
          "مسئولیت صحت، قانونی بودن و امنیت داده‌های آپلودشده توسط مشتریان نهایی بر عهده کاربر است.",
          "ترندی اسمارت تعهدی در قبال محتوای تولیدی یا ارسالی کاربران و مشتریان نهایی ندارد.",
          "نقض قوانین تجارت الکترونیک ایران یا بارگذاری محتوای غیرقانونی منجر به تعلیق حساب خواهد شد.",
        ]}
      />
    ),
  },
  {
    id: "prohibited",
    title: "محتوا و استفاده‌های ممنوع",
    icon: Ban,
    highlight:
      "تخلف از این موارد منجر به تعلیق فوری حساب و در صورت لزوم، ارجاع به مراجع قانونی می‌شود.",
    body: (
      <LegalList
        items={[
          "اسپم، پیام‌های انبوه ناخواسته و تبلیغات مزاحم.",
          "محتوای غیراخلاقی، توهین‌آمیز یا مغایر قوانین جمهوری اسلامی ایران.",
          "فعالیت‌های غیرقانونی شامل قمار، شرط‌بندی، فروش دارو یا مواد غیرمجاز، فروش VPN غیرمجاز.",
          "نقض قوانین پلتفرم‌های متصل (اینستاگرام، تلگرام، واتس‌اپ و …).",
          "سوءاستفاده از دوره‌های آزمایشی، ایجاد حساب‌های جعلی یا چندگانه برای دور زدن محدودیت‌ها.",
          "تلاش برای نفوذ، Reverse Engineering، اختلال در سرویس یا حملات DDoS.",
          "جمع‌آوری داده دیگر کاربران بدون اجازه (Scraping) از داشبورد یا API.",
        ]}
      />
    ),
  },
  {
    id: "ai-usage",
    title: "استفاده مسئولانه از هوش مصنوعی",
    icon: Bot,
    body: (
      <LegalList
        items={[
          "پاسخ‌های هوش مصنوعی صرفاً ابزار کمکی هستند؛ مسئولیت نهایی پیام ارسالی به مشتریان با کاربر است.",
          "آموزش ربات با محتوای دارای حق نشر دیگران یا اطلاعات گمراه‌کننده ممنوع است.",
          "استفاده از هوش مصنوعی برای تولید محتوای غیراخلاقی، فریب‌کارانه یا مزاحمت ممنوع است.",
          "بازبینی و تنظیم پاسخ‌های ربات پیش از فعال‌سازی پاسخ خودکار به کاربر توصیه می‌شود.",
        ]}
      />
    ),
  },
  {
    id: "payment",
    title: "پرداخت و اشتراک",
    icon: CreditCard,
    body: (
      <LegalList
        items={[
          "کلیه مبالغ به تومان محاسبه و در فاکتور درج می‌شوند.",
          "در صورت اعمال مالیات بر ارزش افزوده یا عوارض قانونی جدید، کاربر موظف به پرداخت آن خواهد بود.",
          "پیش از خرید از تطابق پلن با نیاز خود مطمئن شوید.",
          "قرارداد استفاده تنها به اندازه مدت اعتبار اشتراک فعال است و پس از پایان، در صورت عدم تمدید، دسترسی به ابزارها متوقف می‌شود.",
          "اشتراک شخصی است و قابل انتقال یا فروش به اشخاص ثالث نیست.",
          "صورتحساب‌ها از طریق ایمیل و داشبورد در اختیار کاربر قرار می‌گیرد.",
        ]}
      />
    ),
  },
  {
    id: "support",
    title: "پشتیبانی و خدمات",
    icon: LifeBuoy,
    body: (
      <LegalList
        items={[
          "پشتیبانی از طریق تیکت داشبورد، ایمیل، چت آنلاین، جلسات آنلاین و ربات تلگرام ارائه می‌شود.",
          "زمان پاسخ‌گویی متناسب با اولویت پلن اشتراکی شما متغیر است و در صفحه پلن‌ها قابل مشاهده است.",
          "ترندی اسمارت می‌تواند خدمات را به‌طور موقت برای نگهداری، امنیت یا به‌روزرسانی تعلیق کند؛ موارد برنامه‌ریزی‌شده از قبل اطلاع‌رسانی می‌شود.",
          "درخواست‌های توسعه قابلیت اختصاصی تنها با اشتراک‌های سازمانی قابل بررسی است.",
        ]}
      />
    ),
  },
  {
    id: "responsibilities",
    title: "مسئولیت‌ها و محدودیت‌ها",
    icon: ShieldAlert,
    body: (
      <LegalList
        items={[
          "ترندی اسمارت تلاش می‌کند خدمات پایدار ارائه دهد، اما در مواردی چون قطعی اینترنت، فیلترینگ، تحریم‌ها یا تغییر API پلتفرم‌ها مسئولیتی ندارد.",
          "کلیه مسئولیت‌های قانونی محتوای بارگذاری‌شده توسط کاربر یا مشتریان نهایی او بر عهده کاربر است.",
          "اقدامات اعضای تیم یا ادمین‌هایی که کاربر دسترسی داده، به حساب کاربر اصلی منظور می‌شود.",
          "حداکثر مسئولیت مالی ترندی اسمارت در هر شرایط، محدود به مبلغی است که کاربر طی آخرین دورهٔ اشتراک پرداخت کرده است.",
          "ترندی اسمارت هیچ تضمینی برای افزایش فروش، فالوور یا موفقیت تجاری نمی‌دهد؛ نتایج بسته به نوع کسب‌وکار و کیفیت اجرا متفاوت خواهد بود.",
          "SLA پایداری در سطح ۹۹.۵٪ ماهانه هدف‌گذاری شده، اما تضمین قطعی نیست.",
        ]}
      />
    ),
  },
  {
    id: "age",
    title: "سن و اهلیت قانونی",
    icon: CalendarCheck,
    body: (
      <LegalList
        items={[
          "استفاده از خدمات صرفاً برای افراد بالای ۱۸ سال مجاز است.",
          "افراد زیر ۱۸ سال تنها با اجازه و نظارت والدین یا سرپرست قانونی می‌توانند از سرویس استفاده کنند.",
          "تمامی مسئولیت‌های قانونی و مالی استفاده توسط افراد زیر سن قانونی بر عهده والدین یا سرپرست خواهد بود.",
        ]}
      />
    ),
  },
  {
    id: "changes",
    title: "تغییرات در قوانین و خدمات",
    icon: RefreshCw,
    body: (
      <LegalList
        items={[
          "ترندی اسمارت حق دارد در هر زمان قوانین، تعرفه‌ها و خدمات را تغییر دهد.",
          "ادامه استفاده پس از انتشار تغییرات به منزله پذیرش آن‌ها است.",
          "آخرین نسخه قوانین همواره در وب‌سایت منتشر می‌شود؛ در صورت تغییرات اساسی، در ورود مجدد ملزم به تأیید قوانین جدید خواهید بود.",
          "ترندی اسمارت می‌تواند هر سرویس یا پلن را در هر زمان تغییر، محدود یا متوقف کند.",
        ]}
      />
    ),
  },
  {
    id: "termination",
    title: "خاتمهٔ حساب کاربری",
    icon: UserX,
    body: (
      <LegalNumbered
        items={[
          "نقض قوانین جمهوری اسلامی ایران یا قوانین پلتفرم‌های متصل.",
          "استفاده غیرقانونی، اسپم یا فعالیت‌های ممنوع ذکرشده در این سند.",
          "عدم پرداخت به‌موقع یا پایان دورهٔ اشتراک بدون تمدید.",
          "سوءاستفاده از دورهٔ آزمایشی یا ایجاد حساب‌های فیک.",
          "گزارش‌های متعدد از سوی مشتریان نهایی مبنی بر مزاحمت یا کلاهبرداری.",
        ]}
      />
    ),
  },
  {
    id: "ip",
    title: "مالکیت معنوی",
    icon: Copyright,
    body: (
      <LegalList
        items={[
          "کلیه حقوق مادی و معنوی نرم‌افزار، برند، لوگو، کدها، طراحی، مستندات و محتوای آموزشی متعلق به ترندی اسمارت است.",
          "هرگونه کپی، فروش مجدد، Reverse Engineering یا استفاده خارج از توافق ممنوع است.",
          "محتوای تولیدشده توسط کاربر در داشبورد متعلق به خود کاربر است؛ ترندی اسمارت صرفاً جهت ارائه سرویس از آن استفاده می‌کند.",
        ]}
      />
    ),
  },
  {
    id: "dispute",
    title: "حل اختلاف",
    icon: Scale,
    body: (
      <LegalList
        items={[
          "در صورت بروز اختلاف، طرفین ابتدا تلاش خواهند کرد از طریق مذاکره و پشتیبانی موضوع را حل کنند.",
          "در صورت عدم توافق، مرجع رسیدگی، دادگاه‌های صالح شهر تهران خواهد بود.",
          "کاربر می‌پذیرد ادعاهای مالی او محدود به سقف مذکور در بند مسئولیت‌ها است.",
        ]}
      />
    ),
  },
  {
    id: "communications",
    title: "ارتباطات رسمی",
    icon: Mail,
    body: (
      <LegalList
        items={[
          "اطلاع‌رسانی‌های رسمی از طریق ایمیل، پیامک، اعلان داشبورد یا تماس تلفنی انجام می‌شود.",
          "کاربر موظف است اطلاعات تماس خود (ایمیل و موبایل) را به‌روز نگه دارد.",
          "اعلان‌های مهم در صورت ارسال به آخرین ایمیل/موبایل ثبت‌شده، ابلاغ‌شده تلقی می‌شوند.",
        ]}
      />
    ),
  },
  {
    id: "user-cancel",
    title: "فسخ توسط کاربر",
    icon: LogOut,
    body: (
      <LegalList
        items={[
          "کاربر می‌تواند در هر زمان از طریق داشبورد یا پشتیبانی درخواست فسخ بدهد.",
          "هیچ مبلغی بابت دورهٔ باقی‌مانده اشتراک مسترد نمی‌شود.",
          "پس از فسخ، داده‌های کاربر طبق سیاست حریم خصوصی نگهداری یا حذف خواهند شد.",
        ]}
      />
    ),
  },
  {
    id: "inactive",
    title: "حساب‌های غیرفعال",
    icon: PowerOff,
    body: (
      <LegalList
        items={[
          "حساب‌های کاربری حتی در صورت عدم استفاده طولانی‌مدت فعال باقی می‌مانند.",
          "در صورت عدم پرداخت اشتراک، تنها بخش‌های پرمیوم غیرفعال می‌شوند، اما داده‌های کاربر حفظ می‌شود.",
          "حساب‌های غیرفعال بیش از ۲۴ ماه ممکن است پس از اطلاع‌رسانی، آرشیو شوند.",
        ]}
      />
    ),
  },
  {
    id: "marketing",
    title: "تبلیغات و اطلاع‌رسانی",
    icon: Megaphone,
    body: (
      <LegalList
        items={[
          "کاربر می‌پذیرد ترندی اسمارت علاوه بر اطلاع‌رسانی‌های ضروری، پیشنهادهای تبلیغاتی مرتبط را نیز ارسال کند.",
          "این پیام‌ها از طریق ایمیل، پیامک یا اعلان داشبورد ارسال می‌شوند.",
          "در هر زمان می‌توانید از تنظیمات حساب، اشتراک در پیام‌های تبلیغاتی را غیرفعال کنید.",
        ]}
      />
    ),
  },
  {
    id: "backup",
    title: "بک‌آپ‌گیری از داده‌ها",
    icon: HardDrive,
    body: (
      <LegalList
        items={[
          "ترندی اسمارت تلاش می‌کند به‌صورت روزانه نسخه پشتیبان از داده‌ها تهیه کند.",
          "تضمینی برای بازیابی کامل داده‌ها در همهٔ شرایط وجود ندارد؛ کاربر مسئول نگهداری نسخهٔ پشتیبان از داده‌های حیاتی خود نیز هست.",
          "خروجی داده‌ها به‌صورت دوره‌ای از طریق داشبورد در دسترس است.",
        ]}
      />
    ),
  },
  {
    id: "force-majeure",
    title: "شرایط فورس ماژور",
    icon: CloudLightning,
    body: (
      <LegalList
        items={[
          "ترندی اسمارت در قبال عدم ارائه یا تأخیر ناشی از شرایط خارج از کنترل (قطع اینترنت، فیلترینگ، بلایای طبیعی، تحریم‌ها، حملات سایبری گسترده) هیچ مسئولیتی ندارد.",
          "در چنین شرایطی، تمام تلاش برای بازگرداندن سرویس در سریع‌ترین زمان ممکن انجام می‌شود.",
          "دوره فورس ماژور به مدت اشتراک کاربر اضافه نخواهد شد، مگر در شرایط استثنایی به تشخیص ترندی اسمارت.",
        ]}
      />
    ),
  },
  {
    id: "credentials",
    title: "امنیت اطلاعات ورود",
    icon: KeyRound,
    body: (
      <LegalList
        items={[
          "فعال‌سازی احراز هویت دومرحله‌ای (2FA) برای حساب‌های کسب‌وکار اکیداً توصیه می‌شود.",
          "ترندی اسمارت هیچ‌گاه از طریق پیامک یا تماس تلفنی، رمز عبور شما را درخواست نخواهد کرد.",
          "در صورت دریافت تماس مشکوک، فوراً به پشتیبانی اطلاع دهید.",
        ]}
      />
    ),
  },
  {
    id: "governing-law",
    title: "قوانین حاکم",
    icon: Gavel,
    highlight:
      "کاربر تأیید می‌کند که متن کامل را مطالعه کرده، آن را پذیرفته و خود را ملزم به رعایت آن می‌داند.",
    body: (
      <LegalList
        items={[
          "استفاده از خدمات تابع قوانین جمهوری اسلامی ایران است.",
          "هرگونه ابهام یا تفسیر در این سند بر اساس قوانین تجارت الکترونیک، حمایت از مصرف‌کننده و قانون مدنی ایران تفسیر می‌شود.",
          "نسخه فارسی این سند مبنای رسمی است؛ ترجمه‌های احتمالی صرفاً جنبه راهنمایی دارند.",
        ]}
      />
    ),
  },
];

export default function TermsPage() {
  return (
    <LegalLayout
      kind="terms"
      eyebrow="قوانین و مقررات"
      title="بازی منصفانه، شفاف و الزام‌آور."
      intro="این سند مجموعه شرایط و ضوابط الزام‌آور استفاده از کلیهٔ سرویس‌های ترندی اسمارت است. ثبت‌نام، خرید یا استفاده از خدمات، به منزله پذیرش قطعی این مقررات توسط کاربر است. پذیرش الکترونیکی معادل امضای کتبی و دارای اثر قانونی است."
      updatedAt="۱۴۰۳/۰۲/۱۸"
      effectiveAt="۱۴۰۳/۰۲/۲۰"
      sections={sections}
      sisterTitle="حریم خصوصی"
      sisterHref="/privacy"
      sisterDescription="بدانید چه داده‌هایی از شما جمع‌آوری می‌کنیم و چگونه از آن‌ها محافظت می‌شود."
    />
  );
}
